export enum FACEBOOK_POSTS_TYPES {
  VIDEO = "VIDEO",
  POST = "POST",
}

export const EmbedFacebookService = {
  getEmbedHref({ url }: { url: string }) {
    const facebookIframeURL = new URL(url);
    if (!facebookIframeURL.searchParams.has("href")) {
      throw new Error("RTC / Embeds / Facebook: No HREF param in Facebook Iframe URL");
    } else {
      return facebookIframeURL.searchParams.get("href")!;
    }
  },
  getEmbedType({ href }: { href: string }): FACEBOOK_POSTS_TYPES {
    switch (true) {
      case href.includes("/videos/"):
        return FACEBOOK_POSTS_TYPES.VIDEO;
      case href.includes("/posts/"):
      default:
        return FACEBOOK_POSTS_TYPES.POST;
    }
  },
  getEmbedAttributes({ href, postType }: { href: string; postType: FACEBOOK_POSTS_TYPES }): Record<string, string> {
    switch (postType) {
      case FACEBOOK_POSTS_TYPES.VIDEO:
        return {
          className: "fb-video",
          "data-href": href,
          "data-lazy": "true",
        };
      case FACEBOOK_POSTS_TYPES.POST:
      default:
        return {
          className: "fb-post",
          "data-href": href,
          "data-lazy": "true",
        };
    }
  },
};
